export default __webpack_public_path__ + "static/4-04e85dca0051b026df373a26d7c678e1.jpg";